import { render } from "./HeaderNotice.vue?vue&type=template&id=06fc1488&scoped=true"
import script from "./HeaderNotice.vue?vue&type=script&lang=js"
export * from "./HeaderNotice.vue?vue&type=script&lang=js"

import "./HeaderNotice.vue?vue&type=style&index=0&id=06fc1488&lang=less&scoped=true"

import exportComponent from "/build/cloudstack/dist/rpmbuild/BUILD/cloudstack-4.18.1.0/ui/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-06fc1488"]])

export default __exports__